import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { consumeScrollRestore } from '../utils/scrollRestore';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const saved = consumeScrollRestore();
    if (saved !== null) {
      // Restore scroll position when returning from Experience
      requestAnimationFrame(() => window.scrollTo(0, saved));
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;